module.exports = __webpack_public_path__ + "img/voiture-avec-remorque.ef587f63.svg";